// Messages for operator/Settings (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.settings.head': 'Settings — Operator',
  'operator.settings.title': 'Settings',
  'operator.settings.desc': 'Workspace administration — permission-gated',
  'operator.settings.empty': "You don't have access to any workspace settings.",
  'operator.settings.section.team': 'Team & access',
  'operator.settings.section.communications': 'Communications & content',
  'operator.settings.section.data': 'Data & configuration',
  'operator.settings.section.system': 'System & developer tools',
  // Card titles + descriptions — keys mirror Operator::SettingsController::CARDS.
  'operator.settings.card.staff.title': 'Staff & Roles',
  'operator.settings.card.staff.desc': 'Members, invitations & custom roles',
  'operator.settings.card.security.title': 'Security',
  'operator.settings.card.security.desc': 'SSO sign-in (SAML/OIDC) & SCIM',
  'operator.settings.card.api_keys.title': 'API keys',
  'operator.settings.card.api_keys.desc': 'Scoped keys, rotate & revoke',
  'operator.settings.card.webhooks.title': 'Webhooks',
  'operator.settings.card.webhooks.desc': 'Endpoints & event subscriptions',
  'operator.settings.card.notifications.title': 'Notifications',
  'operator.settings.card.notifications.desc': 'Email / Teams / Slack / SMS destinations',
  'operator.settings.card.announcements.title': 'Announcements',
  'operator.settings.card.announcements.desc': 'Portal banners & broadcasts to customers',
  'operator.settings.card.marketing.title': 'Website content',
  'operator.settings.card.marketing.desc': 'Edit the public marketing site copy',
  'operator.settings.card.metafields.title': 'Metafields',
  'operator.settings.card.metafields.desc': 'Custom fields per model',
  'operator.settings.card.taxonomies.title': 'Taxonomies & Tags',
  'operator.settings.card.taxonomies.desc': 'Operator-defined taxonomies',
  'operator.settings.card.reference.title': 'Reference data',
  'operator.settings.card.reference.desc': 'Locations / ports catalog',
  'operator.settings.card.carriers.title': 'Carriers',
  'operator.settings.card.carriers.desc': 'Shipping lines / airlines & their transport modes',
  'operator.settings.card.integrations.title': 'Integrations',
  'operator.settings.card.integrations.desc': 'Teams, tracking, accounting…',
  'operator.settings.card.features.title': 'Feature flags',
  'operator.settings.card.features.desc': 'Optional modules on/off',
  'operator.settings.card.appearance.title': 'Appearance',
  'operator.settings.card.appearance.desc': 'Operator console color scheme',
  'operator.settings.card.bulk.title': 'Import / Export',
  'operator.settings.card.bulk.desc': 'Bulk data operations',
  'operator.settings.card.data_cleanup.title': 'Data cleanup',
  'operator.settings.card.data_cleanup.desc': 'Merge duplicates & normalize dirty data',
  'operator.settings.card.audit.title': 'Audit log',
  'operator.settings.card.audit.desc': 'Filterable activity trail',
  'operator.settings.card.notification_test.title': 'Notification testing',
  'operator.settings.card.notification_test.desc': 'Send test notifications to a customer or staff',
  'operator.settings.card.diagnostics.title': 'Diagnostics',
  'operator.settings.card.diagnostics.desc': 'App, datastore & queue health',
  'operator.settings.card.jobs.title': 'Background jobs',
  'operator.settings.card.jobs.desc': 'Queue depth, retry & discard',
  'operator.settings.card.system_audit.title': 'System audit',
  'operator.settings.card.system_audit.desc': 'Raw before/after values & system events',
  'operator.settings.card.maintenance.title': 'Maintenance',
  'operator.settings.card.maintenance.desc': 'Caches, reseed, derived data & purges',
  'operator.settings.card.operator_impersonation.title': 'Impersonate operator',
  'operator.settings.card.operator_impersonation.desc': 'Act as another operator for debugging',
}

export const zhTW = {
  'operator.settings.head': '設定 — 操作員',
  'operator.settings.title': '設定',
  'operator.settings.desc': '工作區管理 — 受權限控管',
  'operator.settings.empty': '您沒有存取任何工作區設定的權限。',
  'operator.settings.section.team': '團隊與存取',
  'operator.settings.section.communications': '通訊與內容',
  'operator.settings.section.data': '資料與設定',
  'operator.settings.section.system': '系統與開發者工具',
  // 卡片標題與說明 — 鍵對應 Operator::SettingsController::CARDS。
  'operator.settings.card.staff.title': '員工與角色',
  'operator.settings.card.staff.desc': '成員、邀請與自訂角色',
  'operator.settings.card.security.title': '安全性',
  'operator.settings.card.security.desc': 'SSO 登入（SAML/OIDC）與 SCIM',
  'operator.settings.card.api_keys.title': 'API 金鑰',
  'operator.settings.card.api_keys.desc': '範圍化金鑰、輪換與撤銷',
  'operator.settings.card.webhooks.title': 'Webhook',
  'operator.settings.card.webhooks.desc': '端點與事件訂閱',
  'operator.settings.card.notifications.title': '通知',
  'operator.settings.card.notifications.desc': '電子郵件 / Teams / Slack / SMS 目的地',
  'operator.settings.card.announcements.title': '公告',
  'operator.settings.card.announcements.desc': '客戶入口橫幅與對客戶的廣播',
  'operator.settings.card.marketing.title': '網站內容',
  'operator.settings.card.marketing.desc': '編輯公開行銷網站文案',
  'operator.settings.card.metafields.title': '中繼欄位',
  'operator.settings.card.metafields.desc': '各模型的自訂欄位',
  'operator.settings.card.taxonomies.title': '分類與標籤',
  'operator.settings.card.taxonomies.desc': '操作員定義的分類',
  'operator.settings.card.reference.title': '參考資料',
  'operator.settings.card.reference.desc': '地點 / 港口目錄',
  'operator.settings.card.carriers.title': '承運商',
  'operator.settings.card.carriers.desc': '船公司 / 航空公司及其運輸模式',
  'operator.settings.card.integrations.title': '整合',
  'operator.settings.card.integrations.desc': 'Teams、追蹤、會計…',
  'operator.settings.card.features.title': '功能旗標',
  'operator.settings.card.features.desc': '選用模組開關',
  'operator.settings.card.appearance.title': '外觀',
  'operator.settings.card.appearance.desc': '操作員控制台配色方案',
  'operator.settings.card.bulk.title': '匯入 / 匯出',
  'operator.settings.card.bulk.desc': '大量資料操作',
  'operator.settings.card.data_cleanup.title': '資料清理',
  'operator.settings.card.data_cleanup.desc': '合併重複並正規化雜亂資料',
  'operator.settings.card.audit.title': '稽核日誌',
  'operator.settings.card.audit.desc': '可篩選的活動軌跡',
  'operator.settings.card.notification_test.title': '通知測試',
  'operator.settings.card.notification_test.desc': '傳送測試通知給客戶或員工',
  'operator.settings.card.diagnostics.title': '診斷',
  'operator.settings.card.diagnostics.desc': '應用程式、資料儲存與佇列健康狀態',
  'operator.settings.card.jobs.title': '背景工作',
  'operator.settings.card.jobs.desc': '佇列深度、重試與捨棄',
  'operator.settings.card.system_audit.title': '系統稽核',
  'operator.settings.card.system_audit.desc': '原始前後值與系統事件',
  'operator.settings.card.maintenance.title': '維護',
  'operator.settings.card.maintenance.desc': '快取、重新植入、衍生資料與清除',
  'operator.settings.card.operator_impersonation.title': '模擬操作員',
  'operator.settings.card.operator_impersonation.desc': '以其他操作員身分進行除錯',
}
